<div class="flex pb-3 pt-2" [ngClass]="{'items-center justify-between': inline, 'flex-col': !inline}">
  @if (headerDetails$ | async; as details) {
    <div class="space-y-2">
      <h3 data-cy="page-header-title" class="font-medium text-xl leading-none pr-3 font-title flex items-center gap-2">
        <span>{{details.title | translate}}</span>
        @if (hasIntercomArticle()) {
          <button [appTooltip]="details.tooltip | translate" role="button" class="p-1.5 rounded hover:bg-white dark:hover:bg-slate-900 active" 
            (click)="showInfo()">
            <app-svg-images svgName="question-mark-circle-solid" class="h-4.5 flex text-kohort-primary"></app-svg-images>
          </button>
        }
      </h3>
      @if (details.description) {
        <h3 data-cy="page-header-description" class="text-sm text-gray-500 dark:text-white/50 fade-in" [translate]="details.description"></h3>
      }
    </div>
  }
  <div class="flex items-center justify-end gap-2">
    <ng-content></ng-content>
  </div>
</div>
